import gql from 'graphql-tag'

export default gql`
	query CA_getCashBookReport($filter: CashBookReportFilterInput, $params: CashBookReportParamsInput) {
		reports {
			getCashBookReport(filter: $filter, params: $params)
		}
	}
	`
